import { showToast } from './toast'

export const handleApiError = (err: any) => {
  if (Array.isArray(err)) {
    err.slice(0, 3).forEach((item: any) => {
      const message = typeof item === 'object' ? 'Something went wrong' : item

      showToast(message, {
        variant: 'error',
        autoHideDuration: 6000,
      })
    })
  } else {
    const message =
      err instanceof Error
        ? err.message
        : typeof err === 'string'
        ? err
        : err?.message || 'Something went wrong'

    showToast(message, {
      variant: 'error',
      autoHideDuration: 6000,
    })
  }
}
